import { Directive, Input, OnInit, TemplateRef, ViewContainerRef } from "@angular/core";
import { tap } from "rxjs/operators";
import { FeatureConfig, FeatureService } from "./feature.service";

@Directive({
  selector: "[featureEnabled]",
  standalone: false
})
export class FeatureEnabledDirective implements OnInit {
  @Input() set featureEnabled(val: string) {
    if (val) {
      this._featureEnabled = val;
    }
  }
  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainerRef: ViewContainerRef,
    private featureService: FeatureService
  ) {}

  private _featureEnabled = "";

  ngOnInit() {
    this.featureService
      .feature$(this._featureEnabled)
      .pipe(
        tap((data: FeatureConfig | null) => {
          if (data !== null && data["enabled"]) {
            this.viewContainerRef.createEmbeddedView(this.templateRef, {
              $implicit: data
            });
          } else {
            this.viewContainerRef.clear();
          }
        })
      )
      .subscribe();
  }
}
